export default __webpack_public_path__ + "tmp_src/components/DiscountDelivery/DiscountDelivery.css.liquid";